import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { passForwardingQualityGate } from '../../../../../redux/project/sliceProjectWorkflow';
import AlertModalDialog from '../../AlertModalDialog';
import { IAppReduxStore } from '../../../../../redux/store';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'forwardingQualityGateDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();

    const isMainDialogOpen = useSelector(
        (_store: IAppReduxStore) => _store.projectWorkflow.isMainDialogOpen,
    );

    const onCloseForwardingQualityGate = () => {
        dispatch(passForwardingQualityGate());
    };
    return (
        <AlertModalDialog
            isOpen={isMainDialogOpen}
            onClose={onCloseForwardingQualityGate}
            onConfirm={onCloseForwardingQualityGate}
            dialogTitle={t('forwardingQualityGateDialogTitle')}
            dialogBody={t('forwardingQualityGateDialogBody')}
            confirmText={t('ctaOk')}
            isActionDisabled={false}
        />
    );
};
